export function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
export const trimString = (inStr: string, maxChars: number) => {
  if (inStr.length > maxChars) {
    return inStr.slice(0, maxChars) + "...";
  } else {
    return inStr;
  }
};
